import { useState, useEffect } from "react";
import { Phone } from "lucide-react";
import { trackCallConversion } from "@/lib/tracking";

const StickyCallButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show after user scrolls past the hero so it doesn't fight the primary CTA
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href="tel:4847643392"
      onClick={() => trackCallConversion("sticky_call_now_button")}
      data-testid="sticky-call-now-btn"
      aria-label="Call Blue Collar World Pest Control now at 484-764-3392"
      className={`fixed bottom-6 right-6 md:bottom-8 md:right-8 z-40 inline-flex items-center gap-3 bg-[#D9480F] hover:bg-[#E8590C] text-white font-display uppercase tracking-tight text-base md:text-lg px-6 py-4 md:px-8 md:py-5 border-2 border-black hard-shadow transition-all duration-300 ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <span className="relative flex items-center justify-center w-5 h-5 md:w-6 md:h-6">
        <span className="absolute inline-flex h-full w-full rounded-full bg-white opacity-40 animate-ping" />
        <Phone className="relative w-5 h-5 md:w-6 md:h-6" strokeWidth={2.8} />
      </span>
      <span className="whitespace-nowrap">Call Us Now</span>
    </a>
  );
};

export default StickyCallButton;
